import { forwardRef } from "react";
import { ControllerRenderProps } from "react-hook-form";
import EnumSelect from "@/components/EnumSelect";
import { VALIDATION } from "@/schemas/question/validation";

const ValidationTypeSelect = forwardRef<
  HTMLButtonElement,
  ControllerRenderProps
>((props, ref) => (
  <EnumSelect
    options={VALIDATION}
    translationKey="validationTypes"
    {...props}
    ref={ref}
  />
));

export default ValidationTypeSelect;
